import { render } from "./productcard.vue?vue&type=template&id=05cc60e5"
import script from "./productcard.vue?vue&type=script&lang=js"
export * from "./productcard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__